import React, { useEffect, useState } from 'react';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('nav-open', isMenuOpen);
    return () => {
      document.body.classList.remove('nav-open');
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isMenuOpen ? 'header--open' : ''}`}>
      <div className="header-inner">
        <button
          type="button"
          className={`menu-toggle ${isMenuOpen ? 'menu-toggle--open' : ''}`}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Menü schließen' : 'Menü öffnen'}
          aria-controls="primary-navigation"
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
        <nav id="primary-navigation" className="nav" aria-label="Hauptnavigation">
          <a href="#about" onClick={(e) => handleScroll(e, 'about')}>MILCHKETTENMUSIK</a>
          <a href="#referenzen" onClick={(e) => handleScroll(e, 'referenzen')}>REFERENZEN</a>
          <a href="#studio" onClick={(e) => handleScroll(e, 'studio')}>DAS STUDIO</a>
          <a href="#kontakt" onClick={(e) => handleScroll(e, 'kontakt')}>KONTAKT</a>
        </nav>
      </div>
      <div className="nav-overlay" onClick={() => setIsMenuOpen(false)} />
    </header>
  );
}

export default Header;
